import { createFileRoute } from '@tanstack/react-router'
import { handleOAuthCallbackFn } from '@/server/functions/auth'
import { z } from 'zod'

const callbackSearchSchema = z.object({
  userId: z.string(),
  secret: z.string(),
  redirect: z.string().optional(),
  redirectToPayment: z.string().optional(),
  productId: z.string().optional(),
})

export const Route = createFileRoute('/callback')({
  validateSearch: callbackSearchSchema,
  loader: async ({ location }) => {
    const search = location.search
    // @ts-expect-error asasa
    await handleOAuthCallbackFn({ data: search })
  },
  component: () => (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 text-white">
      <div className="text-center">
        <h2 className="mb-2 text-xl font-medium">Authenticating...</h2>
        <p className="text-slate-400">
          Please wait while we complete your sign-in.
        </p>
      </div>
    </div>
  ),
})
